import * as React from "react";
const SvgArrow = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 7.723, height: 14.445, viewBox: "0 0 7.723 14.445", ...props }, /* @__PURE__ */ React.createElement("path", { stroke: "currentColor", d: "M5.354-1.718-1.364 5l6.718 6.718", style: {
  fill: "none",
  fillRule: "evenodd",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeOpacity: 1
}, transform: "translate(1.864 2.223)" }));
export default SvgArrow;
